<script lang="ts" setup>
import { ErrorMessage } from 'vee-validate';
import { toValue } from 'vue';
import { useFormField } from './useFormField';

const { name, formMessageId } = useFormField();

</script>

<template>
  <ErrorMessage :id="formMessageId" v-slot="{ message }" :name="toValue(name)">
    <div v-dompurify-html="message" class="text-body--xsmall font-medium text-[color:var(--input-error-border)]" />
  </ErrorMessage>
</template>

<style>
a.rich-validation-text {

  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}
</style>
